var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 27C20.9558 27 27 20.9558 27 13.5C27 6.04416 20.9558 0 13.5 0C6.04416 0 0 6.04416 0 13.5C0 20.9558 6.04416 27 13.5 27ZM11.3182 8.93176C10.6592 8.27275 9.59077 8.27275 8.93176 8.93176C8.27275 9.59077 8.27275 10.6592 8.93176 11.3182L11.1135 13.5L8.93176 15.6818C8.27275 16.3408 8.27275 17.4092 8.93176 18.0682C9.59077 18.7273 10.6592 18.7273 11.3182 18.0682L13.5 15.8865L15.6818 18.0682C16.3408 18.7273 17.4092 18.7273 18.0682 18.0682C18.7273 17.4092 18.7273 16.3408 18.0682 15.6818L15.8865 13.5L18.0682 11.3182C18.7273 10.6592 18.7273 9.59077 18.0682 8.93176C17.4092 8.27275 16.3408 8.27275 15.6818 8.93176L13.5 11.1135L11.3182 8.93176Z",
    fill: "#C31E13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.88fa6b38.svg";
export { ForwardRef as ReactComponent };